import { Injectable } from '@angular/core';
import {CompanyInvoiceResponse} from "../common/interfaces";
import {Observable, tap} from "rxjs";
import {environment} from "../../environments/environment";
import {HttpClient} from "@angular/common/http";
import {GlobalConstants} from "../common/global";

@Injectable({
  providedIn: 'root'
})
export class CompanyInvoiceService {
  constructor(private readonly http: HttpClient) {}

  getCompanyInvoiceFormData(): Observable<CompanyInvoiceResponse> {
    const url = `${environment.apiUrl}/conn/${environment.connId}/v1/orders/invoice-data`;
    return this.http.get<CompanyInvoiceResponse>(url, GlobalConstants.headersCentral).pipe(
      tap((response: any) => {
        return response;
      })
    );
  }

  submitCompanyInvoiceData(payload: any, transactionId: number): Observable<{ success: boolean }> {
    const url = `${environment.apiUrl}/conn/${environment.connId}/v1/orders/invoice-data/${transactionId}`;
    return this.http.post<{ success: boolean }>(url, payload, GlobalConstants.headersCentral).pipe(
      tap((response: any) => {
        return response;
      })
    )
  }
}
